/* eslint-disable */
import axios from 'axios'

import { AuthService } from './AuthService'
const auth = new AuthService()

const ADMIN_API_URL = process.env.ADMIN_API_URL
const BUSINESS_API_URL = process.env.BUSINESS_API_URL
const COMMON_API_URL = process.env.COMMON_API_URL
const INDIVIDUAL_API_URL = process.env.INDIVIDUAL_API_URL
const SERVICE_API_URL = process.env.SERVICE_API_URL

export class APIService {

  constructor(){ }

  // Create Functions
  createAccount(fields) {
    const url = `${COMMON_API_URL}/users`
    const headers = auth.getCommonApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createProfile(fields) {
    const url = `${COMMON_API_URL}/profiles`
    const headers = auth.getCommonContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createUserCards(fields){
    const url = `${INDIVIDUAL_API_URL}/cards`
    const headers = auth.getCommonContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createBusinessPasses(fields){
    const url = `${BUSINESS_API_URL}/passes`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.post(url, fields, headers).then(response => response.data).catch(err => err.response.data)
  }

  createIndividualPasses(fields){
    const url = `${INDIVIDUAL_API_URL}/individual_passes`
    const headers = auth.getIndividualContentAuthHeader()
    return axios.post(url, fields, headers)//.then(response => response.data).catch(err => err.response.data)
  }

  createUpdatePassInvites(fields) {
    const url = `${BUSINESS_API_URL}/pass_invites`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createScanPass(fields) {
    // fields: pass_id, individual_pass_id, individual_user_id, scanned_by_user_id
    const url = `${BUSINESS_API_URL}/scanned_passes`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createAgreement(fields) {
    // fields: user_id, agreement_name, content, type
    const url = `${BUSINESS_API_URL}/agreements`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createBusinessRequests(fields) {
    // fields: requestor_name, requestor_user_id, pass_id, owner_id
    const url = `${BUSINESS_API_URL}/pass_requests`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  createCompany(fields) {
    const url = `${BUSINESS_API_URL}/companies`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }
  //---> End Create Functions

  //---> Update Functions
  updateCards(card_id, fields) {
    const url = `${INDIVIDUAL_API_URL}/cards/${card_id}`
    const headers = auth.getIndividualContentAuthHeader()
    return axios.put(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updatePass(pass_id, fields) {
    const url = `${BUSINESS_API_URL}/passes/${pass_id}`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.put(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateProfile(user_id, fields) {
    const url = `${COMMON_API_URL}/users/${user_id}/profile`
    const headers = auth.getCommonContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateProfilePicture(user_id, fields) {
    const url = `${COMMON_API_URL}/users/${user_id}/profile_picture`
    const headers = auth.getCommonContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateValidIds(user_id, fields) {
    const url = `${COMMON_API_URL}/users/${user_id}/valid_ids`
    const headers = auth.getCommonContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateIndividualPassAccept(pass_id, fields) {
    const url = `${INDIVIDUAL_API_URL}/individual_passes/${pass_id}/accept`
    const headers = auth.getIndividualContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateIndividualPassReview(pass_id, fields) {
    const url = `${INDIVIDUAL_API_URL}/individual_passes/${pass_id}/review`
    const headers = auth.getIndividualContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateIndividualPassShareDetails(pass_id, fields) {
    const url = `${INDIVIDUAL_API_URL}/individual_passes/${pass_id}/share_details`
    const headers = auth.getIndividualContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updatePassStatus(pass_id, fields) {
    // params: { status: 'Active' / 'Pending' / 'Inactive' }
    const url = `${BUSINESS_API_URL}/passes/${pass_id}/status`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateAgreement(agreement_id, fields) {
    // fields: user_id, agreement_name, content, type
    const url = `${BUSINESS_API_URL}/agreements/${agreement_id}`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.put(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  updateUserRequestAccessDate(id, fields) {
    const url = `${ADMIN_API_URL}/user_requests/${id}`
    const headers = auth.getAdminContentAuthHeader()
    return axios.patch(url, fields, headers).then(response => response.data).catch(err => err.response.data)
  }

  updatePassRequestStatus(id, fields) {
    // id = request_id
    // fields: request_status, is_accepted
    const url = `${BUSINESS_API_URL}/pass_requests/${id}`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.patch(url, fields, headers).then(response => response.data).catch(err => err.response.data)
  }

  updateCompanyProfile(id, fields) {
    const url = `${COMMON_API_URL}/companies/${id}/details`
    const headers = auth.getCommonContentAuthHeader()
    return axios.patch(url, fields, headers).then(response => response.data).catch(err => err.response.data)
  }
  //---> End

  //---> Get Functions
  getCompanyDetails(id) {
    const url = `${COMMON_API_URL}/companies/${id}`
    const headers = auth.getCommonContentAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getUserDetails(user_id){
    const url = `${COMMON_API_URL}/users/${user_id}`
    const headers = auth.getCommonContentAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getProfileDetails(user_id){
    const url = `${COMMON_API_URL}/users/${user_id}`
    const headers = auth.getCommonContentAuthHeader()
    return axios.get(url, headers).then(r => r.data).catch(e => e.response.data)
  }

  getUserCards(user_id){
    const url = `${INDIVIDUAL_API_URL}/cards?u=${user_id}`
    const headers = auth.getIndividualContentAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getBusinessPasses(user_id){
    const url = `${BUSINESS_API_URL}/passes?u=${user_id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getIndividualPasses(user_id){
    const url = `${INDIVIDUAL_API_URL}/individual_passes?u=${user_id}`
    const headers = auth.getIndividualAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getUserShareableCards(id){
    const url = `${INDIVIDUAL_API_URL}/sharedcards?l=${id}`
    const headers = auth.getIndividualApiKeyHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getUserShareablePasses(id){
    const url = `${BUSINESS_API_URL}/sharedpasses?l=${id}`
    const headers = auth.getBusinessApiKeyHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getCardDetail(card_id){
    const url = `${INDIVIDUAL_API_URL}/cards/${card_id}`
    const headers = auth.getIndividualAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getPassDetail(pass_id){
    const url = `${BUSINESS_API_URL}/passes/${pass_id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getIndividualPassDetail(pass_id){
    const url = `${INDIVIDUAL_API_URL}/individual_passes/${pass_id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getIndividualPassByUserID(userId){
    const url = `${INDIVIDUAL_API_URL}/individual_passes?u=${userId}`
    const headers = auth.getIndividualAuthHeader()
    return axios.get(url, headers).then(r => r.data).catch(e => e.response.data)
  }

  getIndividualPassWithLinkID(userId, linkId){
    const url = `${INDIVIDUAL_API_URL}/individual_passes?u=${userId}&l=${linkId}`
    console.log('url: ', url)
    const headers = auth.getIndividualAuthHeader()
    return axios.get(url, headers).then(r => r.data).catch(e => e.response.data)
  }

  getBusinessPassInvitesByID(passId){
    const url = `${BUSINESS_API_URL}/pass_invites/${passId}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getBusinessAgreementsByUserID(user_id){
    const url = `${BUSINESS_API_URL}/agreements?u=${user_id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getBusinessAgreementsByID(id){
    const url = `${BUSINESS_API_URL}/agreements/${id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getBusinessAgreementsByRefCode(ref){
    const url = `${BUSINESS_API_URL}/agreements?l=${ref}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getUserRequestByLink(link){
    const url = `${ADMIN_API_URL}/user_requests?l=${link}`
    const headers = auth.getAdminApiKeyHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getPassInviteScans(id) {
    const url = `${BUSINESS_API_URL}/pass_invite_scans/${id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getPassWithGivenUserIdAndAgreementId(userId, agreementId){
    const url = `${BUSINESS_API_URL}/passes?u=${userId}&aid=${agreementId}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getPassRequestByPassId(id) {
    const url = `${BUSINESS_API_URL}/pass_requests?pid=${id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  getPassInviteRequestsByLink(link) {
    const url = `${BUSINESS_API_URL}/pass_invite_requests/${link}`
    const headers = auth.getBusinessAuthHeader()
    return axios.get(url, headers).then(response => response.data).catch(err => err.response.data)
  }

  // Delete
  deactivatePass(pass_id) {
    const url = `${BUSINESS_API_URL}/passes/${pass_id}/is_active`
    const headers = auth.getBusinessContentAuthHeader()
    const fields = { is_active: false }
    return axios.patch(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  deletePass(pass_id) {
    const url = `${BUSINESS_API_URL}/passes/${pass_id}`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.delete(url, headers).then(r => r.data).catch(e => e.response.data)
  }

  deleteUserFromInviteList(pass_id, params) {
    const url = `${BUSINESS_API_URL}/pass_invites/${pass_id}`
    const headers = auth.getBusinessContentAuthHeader()
    return axios.patch(url, params, headers).then(r => r.data).catch(e => e.response.data)
  }

  deleteAgreement(agreement_id) {
    const url = `${BUSINESS_API_URL}/agreements/${agreement_id}`
    const headers = auth.getBusinessAuthHeader()
    return axios.delete(url, headers).then(r => r.data).catch(e => e.response.data)
  }
  //---> End

  // other services
  verifyInvite(fields) {
    // fields should contain (object_name)
    const url = `${SERVICE_API_URL}/verify_invite`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  fetchImage(fields) {
    // fields should contain (object_name)
    const url = `${SERVICE_API_URL}/fetch_image`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  uploadImage(fields) {
    // fields should contain (image_url)
    const url = `${SERVICE_API_URL}/upload_picture`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  uploadID(fields) {
    // fields should contain (image_url)
    const url = `${SERVICE_API_URL}/upload_id`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  sendInviteEmail(fields) {
    // fiels should contain (link_id, email, company_name)
    const url = `${SERVICE_API_URL}/send_invite`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  sendDeletePassEmail(fields) {
    // fiels should contain (email => guestEmail, company_name)
    const url = `${SERVICE_API_URL}/send_delete`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  sendDeactivatePassEmail(fields) {
    // fiels should contain (email (guestEmail), guest_name, company_name, pass_name, company_email)
    const url = `${SERVICE_API_URL}/send_deactivate`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  sendRequestAccessPassEmail(fields) {
    // fiels should contain (company_email, guest_name, guest_email, pass_id, pass_name)
    const url = `${SERVICE_API_URL}/send_request`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  sendRequestAccessPassStatus(fields) {
    // fiels should contain (company_email, company_name, guest_email, request_status, pass_name)
    const url = `${SERVICE_API_URL}/send_request_status`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  // Airtable
  postToMailingListTop(fields) {
    // fields should be { Email }
    const url = `${SERVICE_API_URL}/mailing_list/top`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  postToMailingListBottom(fields) {
    // fields should be { Email }
    const url = `${SERVICE_API_URL}/mailing_list/bottom`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

  postRequestDemo(fields) {
    // fields should be { Email, Firstname, Lastname, Company, MobileNumber }
    const url = `${SERVICE_API_URL}/request_demo`
    const headers = auth.getServiceApiKeyHeader()
    return axios.post(url, fields, headers).then(r => r.data).catch(e => e.response.data)
  }

}



// WEBPACK FOOTER //
// ./src/api/APIService.js